import styles from './SpeedbumpCell.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';
import Markdown from 'react-markdown';

import { SpeedBumpReseller } from 'src/api/contentful/contentTypes.shop';
import cloverMark from 'src/images/icons/clover-mark.svg';
import { isEntry } from 'src/utils/EntryUtil';
import { testAttribute } from 'src/utils/Serenity';
import { ContentfulImage } from '../Contentful/ContentfulImage';
import { Image } from '../Image/Image';
import { TrackedLink } from '../TrackedLink/TrackedLink';

export interface ISpeedbumpCell extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<SpeedBumpReseller>;
  wide?: boolean;
  clickable?: boolean;
  blurb?: string;
}

export const SpeedbumpCell: React.FunctionComponent<ISpeedbumpCell> = ({
  entry, wide, blurb, clickable, className, onClick, ...props
}) => {
  if (!isEntry(entry)) return null;

  const { name, speedbumpLogo, externalRedirectUrl } = entry.fields;

  const content = (
    <>
      {(speedbumpLogo || wide) && (
        <div className={cx(styles.modalCellLogoWrapper, { [styles.modalCellLogoWrapperWide]: wide })}>
          {speedbumpLogo && <ContentfulImage className={styles.modalCellLogo} asset={speedbumpLogo} offset={window.innerHeight * 3} />}
          {!speedbumpLogo && <Image className={styles.modalCellCloverLogo} src={cloverMark} />}
        </div>
      )}
      {blurb && <Markdown className={styles.modalCellBlurb} source={blurb} />}
    </>
  );

  if (clickable) {
    return (
      <div className={styles.modalCell}>
        {React.createElement(!!externalRedirectUrl ? TrackedLink : 'button', {
          'title': name,
          'className': cx(styles.modalCellButton, className),
          'href': externalRedirectUrl,
          'data-test': testAttribute('speedbump-partner', name),
          'onClick': !externalRedirectUrl ? onClick : undefined,
          ...props,
        }, content)}
      </div>
    );
  }

  return (
    <div className={cx(styles.modalCellUnclickableBanner, className)} {...props}>
      {content}
    </div>
  );
};
